module.exports = __webpack_public_path__ + "media/images/bg/patterns/materials-d891d7b6036ef99bd4c45e83f04ce802.svg";